import React from 'react';
import './index.scss'
import {Link} from "react-router-dom";
import arrow from './../../img/arrow.svg'
const Main = () => {
    return (
        <div className={'mainContainer'}>
            <div className={'wrapText'}>
            <div className="mainText">
                Часто компании говорят
                о преимуществах работы в общих словах, без конкретики. Что же кроется за «комфортными условиями и
                дружным коллективом»?
            </div>
            <div className={"secondText"}>
                Мы готовы рассказать больше! Соединяй точки и собирай все картинки, чтобы узнать, что тебя ждет в
                НИПИГАЗе. Если пройдешь все уровни, сможешь выиграть приз от компании!
            </div>
            </div>
            {/*<img src={arrow}/>*/}
            <Link to={'/game/1'}>
            <button onClick={()=>{ // @ts-ignore
                ym(95273517,'reachGoal','start')}}>
                1, 2, 3… Вперёд!
            </button>
            </Link>
        </div>
    );
};

export default Main;
